export class SpilDetails {
    SpilDetailsId: number;
    IncidentRequestId: number;
    Equip: string;
    Tag: string;
    Description: string;
}

